import {
    Box,
  Breadcrumbs,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link, useNavigate } from "react-router-dom";

const MdmTableComponent = () => {

    const navigate = useNavigate();

  const handleViewClick = () => {
    navigate("/mdm-form");
  };

  const handleClick = () => {};

  return (
    <>
    

      <Typography variant="h3" className="mb-2">
        Customer Code Request
      </Typography>
      <TableContainer
        sx={{
          boxShadow: 2,
          borderRadius: "8px",
          margin: "16px 0",
        }}
      >
        <Table sx={{ minWidth: 650, height: "100%" }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
              <TableCell sx={{ fontWeight: "700" }} width={50}>
                SNo
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Created Date
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Last Update Date
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Customer Name
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Mobile Number
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Region
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                BDM Name
              </TableCell>

              <TableCell sx={{ fontWeight: "700" }} align="center">
                Status
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Generated Customer Code
              </TableCell>
              <TableCell sx={{ fontWeight: "700" }} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="center">1.</TableCell>
              <TableCell align="center">28 Aug 2025</TableCell>
              <TableCell align="center">1st Sept 2025</TableCell>
              <TableCell align="center">Rose Smith</TableCell>
              <TableCell align="center">1234567890</TableCell>
              <TableCell align="center">Region 1</TableCell>
              <TableCell align="center">C M Lokesh</TableCell>

              <TableCell align="center">
                {" "}
                <Chip
                  label="Request for Customer Code"
                  color="success"
                  size="small"
                  sx={{ textTransform: "capitalize" }}
                />
              </TableCell>
              <TableCell align="center">{"-"}</TableCell>
              <TableCell align="center">
                <Tooltip title="View" arrow>
                  <IconButton
                    style={{
                      border: "1px solid",
                      borderRadius: "4px",
                      padding: "2px",
                      width: "24px",
                      height: "24px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#fff",
                    }}
                    color="primary"
                    onClick={() => handleViewClick()}
                  >
                    <VisibilityIcon fontSize="small" color="primary" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MdmTableComponent;
